"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionProvider = void 0;
var tslib_1 = require("tslib");
var CollectionProvider = /** @class */ (function () {
    function CollectionProvider() {
    }
    CollectionProvider.isCollectionProvider = function (c) {
        return typeof c.getCollections === 'function';
    };
    CollectionProvider.getCollections = function (c) {
        var collections = [];
        c.forEachField(function (field) {
            var e_1, _a;
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCollections() || [];
            try {
                for (var fieldCaptures_1 = tslib_1.__values(fieldCaptures), fieldCaptures_1_1 = fieldCaptures_1.next(); !fieldCaptures_1_1.done; fieldCaptures_1_1 = fieldCaptures_1.next()) {
                    var fieldCapture = fieldCaptures_1_1.value;
                    collections.push(fieldCapture);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fieldCaptures_1_1 && !fieldCaptures_1_1.done && (_a = fieldCaptures_1.return)) _a.call(fieldCaptures_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        return collections;
    };
    CollectionProvider.getCollectionIds = function (c) {
        var collections = [];
        c.forEachField(function (field) {
            var e_2, _a;
            if (!CollectionProvider.isCollectionProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCollectionIds() || [];
            try {
                for (var fieldCaptures_2 = tslib_1.__values(fieldCaptures), fieldCaptures_2_1 = fieldCaptures_2.next(); !fieldCaptures_2_1.done; fieldCaptures_2_1 = fieldCaptures_2.next()) {
                    var fieldCapture = fieldCaptures_2_1.value;
                    collections.push(fieldCapture);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (fieldCaptures_2_1 && !fieldCaptures_2_1.done && (_a = fieldCaptures_2.return)) _a.call(fieldCaptures_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
        return collections;
    };
    return CollectionProvider;
}());
exports.CollectionProvider = CollectionProvider;
//# sourceMappingURL=collection.provider.js.map